import { HttpStatusCode } from '@angular/common/http';

export interface BackendErrorDetails {
    message: string;
    action: string;
}

// Configuration for known HTTP status codes
const BackendErrorMessages: Record<number, BackendErrorDetails> = {
    [HttpStatusCode.NotFound]: {
        // 404
        message: 'There was a temporary issue communicating with the backend.',
        action: 'Please try again later or contact support if the issue persists.',
    },
    [HttpStatusCode.InternalServerError]: {
        // 500
        message: 'A severe error occurred on the backend.',
        action: 'Please contact support to report the issue.',
    },
    [HttpStatusCode.GatewayTimeout]: {
        // 504
        message: 'The backend did not respond within the expected time. It may be temporarily overloaded.',
        action: 'Please try again later or contact support if the issue persists.',
    },
    0: {
        // Special case for network/CORS errors
        message: 'Could not connect to the backend server. Check your network connection.',
        action: 'Please check your internet connection and try reloading the application.',
    },
};

const DefaultErrorMessage: BackendErrorDetails = {
    message: 'Unknown error occurred during communication with the backend.',
    action: 'Please try again later or contact support.',
};

/**
 * Retrieves the specific error details for a given HTTP status code.
 *
 * @param statusCode The HTTP status code (or 0 for network errors).
 * @returns The message and actions for the user.
 */
export function getBackendErrorDetails(statusCode: number): BackendErrorDetails {
    // We use the status code directly for lookup, defaulting to the generic message.
    return BackendErrorMessages[statusCode] || DefaultErrorMessage;
}
